"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SessionTicket_1 = require("./Protocol/SessionTicket");
const Session_1 = require("./Session");
function BuildSessionLog(logger, st, messageProvider, callerMemberName = "") {
    //如果是Debug就不要輸出
    if (!logger.isDebugEnabled)
        return "";
    const callMemberNameStr = callerMemberName ? `${callerMemberName}: ` : "";
    if (st instanceof Session_1.Session) {
        return `${callMemberNameStr}[${st.id}][${st.Type}]: ${messageProvider()}`;
    }
    else if (st instanceof SessionTicket_1.SessionTicket) {
        return `${callMemberNameStr}[${st.id}][${st.type}]: ${messageProvider()}`;
    }
    else {
        return messageProvider();
    }
}
exports.default = BuildSessionLog;
/*
//becasue current logger only show code position from calling log.info, so we can't use same way as in C#.
export class SessionLogUtil {
  public static warn(logger: ILogger, st: SessionTicket|Session, messageProvider: Func0<string>, callerMemberName: string = ""): void {
    logger.warn(SessionLogUtil.BuildSessionLog(st, messageProvider, callerMemberName));
  }

  public static info(logger: ILogger, st: SessionTicket|Session, messageProvider: Func0<string>, callerMemberName: string = ""): void {
    logger.info(SessionLogUtil.BuildSessionLog(st, messageProvider, callerMemberName));
  }

  public static debug(logger: ILogger, st: SessionTicket|Session, messageProvider: Func0<string>, callerMemberName: string = ""): void {
    logger.debug(SessionLogUtil.BuildSessionLog(st, messageProvider, callerMemberName));
  }

  public static error(logger: ILogger, st: SessionTicket|Session, messageProvider: Func0<string>, e?: Error, callerMemberName: string = ""): void {
    if (e) {
      logger.error(SessionLogUtil.BuildSessionLog(st, messageProvider, callerMemberName), e);
    } else {
      logger.error(SessionLogUtil.BuildSessionLog(st, messageProvider, callerMemberName));
    }
  }

  public static BuildSessionLog(st: SessionTicket|Session, messageProvider: Func0<string>, callerMemberName: string=""): string {
    const callMemberNameStr = callerMemberName ? callerMemberName : "";
    if (st instanceof Session) {
      return `${callMemberNameStr}: [${st.id}][${st.Type}]: ${messageProvider()}`;
    } else if (st instanceof SessionTicket) {
      return `${callMemberNameStr}: [${st.id}][${st.type}]: ${messageProvider()}`;
    } else {
      return messageProvider();
    }
  }
}
*/ 
//# sourceMappingURL=SessionLogUtil.js.map